import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSectionCarousel from 'eco-design/sections/eco-section-carousel';
import EcoVideoItems from 'eco-design/sections/eco-video-items';
import styles from './index.module.scss';
import gtm from '@/utils/gtm';

// import EcoGraphicSwiper from 'eco-design/sections/eco-graphic-swiper';
const SuperchargeSectionStatusC = () => {
    const { t } = useLang('theProduct.SuperchargeSectionStatusC');

    const itemsA = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1760946857828/card1-pc.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1760946857638/card1-h5.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1760946857638/card1-h5.jpg',
            title: t('card1'),
            desc: t('card1Desc'),
            useName1: t('card1Desc'),
            icon: '',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1760946858871/card2-pc.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1760946859119/card2-h5.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1760946859119/card2-h5.jpg',
            title: t('card2'),
            desc: t('card2Desc'),
            useName1: t('card2Desc'),
            icon: '',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1761534058556/card3-pc.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1761534058291/card3-h5.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1761534058291/card3-h5.jpg',
            title: t('card3'),
            desc: t('card3Desc'),
            useName1: t('card3Desc'),
            icon: '',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1755596247203/Frame%201000009373.png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1755659943986/%E5%9B%BE%E7%89%87%20(3).png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1755659943986/%E5%9B%BE%E7%89%87%20(3).png',
            title: t('card4'),
            desc: t('card4Desc'),
            useName1: t('card4Desc'),
            icon: '',
        },
    ];
    return (
        <section
            className={`${styles.SuperchargeSectionStatusC} SuperchargeC GtmModuleData-section`}
            id="SuperchargeSectionStatusC"
            data-section-id={styles.SuperchargeSectionStatusC}
            data-section-title={t('title')}
        >
            <div className="text-container">
                <p className="label">{t('label')}</p>
                <h2 className="title">{t('title')}</h2>
                <p className="intro">{t('desc')}</p>
            </div>
            <div
                className="btn-container GtmModuleData-btn-href"
                onClick={() => {
                    gtm.push({
                        __btn_id1: 'SuperchargeC .btn-container',
                        __btn_id2: 'https://www.ecoflow.com/us/ocean-pro-home-solar-battery',
                        __btn_type: 'href',
                    });
                    window.open('https://www.ecoflow.com/us/ocean-pro-home-solar-battery', '_self');
                }}
            >
                <button className="primary-btn">{t(`btn`)}</button>
            </div>
            <div className="pc-swiper">
                <EcoSectionCarousel
                    className="carousel"
                    gtmTitle={t('title')}
                    headerLayout="header-top"
                    pagination
                    items={itemsA}
                    // swiperAutoPlay
                    // isOpenDotsGTM
                    // autoplay={{
                    //     delay: 5000,
                    //     stopOnLastSlide: false,
                    //     disableOnInteraction: false,
                    //     animationNavigationRight: true,
                    //     viewport: {
                    //         open: true,
                    //     },
                    // }}
                />
            </div>
            <div className="h5-content">
                <EcoVideoItems items={itemsA} />
            </div>
            {/* <EcoGraphicSwiper uiType="ui4" imgHeight="5-3" items={list} /> */}
            <EcoSpace />
        </section>
    );
};

export default SuperchargeSectionStatusC;
